import {
  Error403View,
  Error404View,
  Error50xView,
  ErrorUnknownView,
  ExpiredLinkView,
} from '@/views/errors';

export default [
  {
    path: '/not-found',
    name: 'app_not_found',
    component: Error404View,
    meta: { title: 'Page Not Found' },
  },
  {
    path: '/:notFound(.*)',
    redirect: '/not-found',
  },
  {
    path: '/events',
    redirect: '/',
  },
  {
    path: '/access-denied',
    name: 'app_forbidden',
    component: Error403View,
    meta: { title: 'Access Denied' },
  },
  {
    path: '/server-error',
    name: 'app_server_error',
    component: Error50xView,
    meta: { title: 'Server Error' },
  },
  {
    path: '/unknown-error',
    name: 'app_unknown_error',
    component: ErrorUnknownView,
    meta: { title: 'Unknown Error' },
  },
  {
    path: '/expired-link',
    name: 'app_expired_link',
    component: ExpiredLinkView,
    meta: { title: 'Expired Link' },
  },
];
